import React, { useEffect, useState } from "react";
import { queryAllDocsByFieldSnap } from "../../../utils/firebase/Firebase.utils";
import { slicedData } from "../../../utils/EleghoUtils";
import BentoTable from "../../../components/BentoTable";
import PageModal from "../Components/PageModal";
import GatePassCard from "../Security/GatePassCard";
import GatePassDetailsPage from "../Security/GatePassDetailsPage";

export default function ResidentGatePass({ identifier }) {
  const [concerns, setConcerns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [numberOfItemPerPage, setNumberOfItemPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedForView, setSelectedForView] = useState(null);
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    const fetchConcerns = async () => {
      await queryAllDocsByFieldSnap(
        "gatePass",
        "identifier",
        "==",
        identifier,
        (data) => {
          setConcerns(data);
          setLoading(false);
        }
      );
    };
    fetchConcerns();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const dataSliced = slicedData(concerns, numberOfItemPerPage, currentPage);

  const handleViewMode = (concern) => {
    setViewMode(true);
    setSelectedForView(concern);
  };

  return (
    <div>
      <BentoTable
        label="Gate Pass"
        data={dataSliced}
        numberOfItemPerPage={numberOfItemPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      >
        {concerns.map((concern, index) => (
          <div onClick={() => handleViewMode(concern)} key={index}>
            <GatePassCard data={concern} />
          </div>
        ))}
      </BentoTable>

      {viewMode && (
        <PageModal>
          <GatePassDetailsPage
            data={selectedForView}
            setViewMode={() => setViewMode(false)}
          />
        </PageModal>
      )}
    </div>
  );
}
